L.VueControl = L.Control.extend({
    initialize: function(_Class, options) {
        L.setOptions(this, options);

        this.options.vm = new _Class({ data: options });
        this.options.vm.$mount(L.DomUtil.create('div'))
    },

    onAdd: function() {
        return this.options.vm.$el;
    }
});

L.vueControl = function(_Class, options) {
    return new L.VueControl(_Class, options);
}


// WEBPACK FOOTER //
// ./src/components/VueControl.js